import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const features = ['Patrones separados por nivel de dificultad', 'Visual moderno, claro y fácil de seguir', 'Funciona en celular, tablet y computadora', 'Acceso para siempre con un solo pago'];
export function MethodIntro() {
  return <section className="relative overflow-hidden bg-[#FDFBF7] py-16 sm:py-24" aria-labelledby="method-intro-title" data-id="element-92" data-mp="20nutbhgh65zo">
      {/* Subtle horizontal stripes background */}
      <div className="absolute inset-0 opacity-40" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 39px, #E8E1D5 39px, #E8E1D5 40px)'
    }} aria-hidden="true" data-id="element-93" data-mp="2ak7jw6gq43q7" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-[1fr_0.8fr] lg:gap-16" data-id="element-94" data-mp="2ocnqfh8u2jvv">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.55
      }} data-id="element-95" data-mp="2tbh2d58h22tx">
          <span className="text-sm font-bold uppercase tracking-[0.15em] text-terracotta/80" data-id="element-96" data-mp="3q1rl3yxiuaxm">
            El método por dentro
          </span>
          <h2 id="method-intro-title" className="mt-3 font-display text-4xl font-black leading-[1.1] text-[#3D2B1F] sm:text-5xl lg:text-[3.5rem]" data-id="element-97" data-mp="3l36jbv2mfj72">
            Tu biblioteca de patrones en la palma de tu mano
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[#5C4D42] sm:text-xl" data-id="element-98" data-mp="cmuz5yjasr82">
            Abrí la guía, elegí el amigurumi que vas a hacer hoy y empezá en segundos. Todo
            organizado paso a paso, con explicaciones claras y acceso 24h.
          </p>

          <ul className="mt-8 space-y-4" data-id="element-99" data-mp="2vh0tu331xgi">
            {features.map(feature => <li key={feature} className="flex items-center gap-3 text-lg text-[#3D2B1F]" data-id="element-100" data-mp="10esaloiu5h8n">
                <CheckIcon className="h-6 w-6 shrink-0 text-sage" strokeWidth={3} aria-hidden="true" data-id="element-101" data-mp="vjw4xlkoevd2" />
                <span data-id="element-102" data-mp="2pvxjl30ptw3y">{feature}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="relative mx-auto w-full max-w-sm lg:max-w-none" data-id="element-103" data-mp="2tx91snh9ff24">
          <img src="https://cdn.magicpatterns.com/uploads/cy2qghHWLUd4f8jP7eqEuF/ChatGPT_Image_11_ago_2026,_11_18_16_a.m..png" alt="Patrón detallado de zorrito amigurumi en un celular" className="h-auto w-full drop-shadow-2xl" data-id="element-104" data-mp="267y9ludz6szl" />
        </motion.div>
      </div>
    </section>;
}